"use strict";
exports.__esModule = true;
exports.PAST_DUE_RENT = void 0;
exports.PAST_DUE_RENT = {
    RENT_TRACKER: {
        MAIN_TEXT: 'You have rent overdue on your portal',
        SUB_TEXT: 'Pay off the overdue amount on your rent portal so you can use Flex this month.',
        CTA: 'Pay balance'
    },
    SERVICE_ISSUE_SCREEN: {
        BOLD_MAIN_TEXT: 'Overdue rent amount',
        MAIN_TEXT: 'Pay off the overdue amount on your rent portal to use Flex.',
        SUB_TEXT: 'We’ll continue to check if your overdue bill has been paid until the {{bpEndDay}}. If it is not paid by the {{bpEndDay}}, you will not be able to use Flex this month.',
        PRIMART_CTA_TEXT: 'Done'
    },
    OVERDUE_BALANCE: {
        HEADLINE: 'Overdue rent to your property',
        SUBTITLE: 'Unfortunately, we are unable to pay rent for accounts with overdue rent. Pay off the overdue amount to your property so you can use Flex next month.',
        CTA: 'Close'
    }
};
